import Container from "@/components/common/Container";
import useOnScreen from "hooks/useOnScreen";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import Title from "./common/Title";

const Ui = () => {
  const ResponsiveUIImageReference = useRef(null);
  const ResponsiveUISecondImageReference = useRef(null);
  const isVisible = useOnScreen(ResponsiveUIImageReference);
  const isVisibleSecondImage = useOnScreen(ResponsiveUISecondImageReference);
  const [imageVisible, setImageVisible] = useState(isVisible);
  const [secondImageVisible, setSecondImageVisible] =
    useState(isVisibleSecondImage);
  useEffect(() => {
    if (isVisible) {
      setImageVisible(isVisible);
    }
    if (isVisibleSecondImage) {
      setImageVisible(setSecondImageVisible);
    }
  }, [isVisible, isVisibleSecondImage]);
  return (
    <Container className="py-20 xl:py-36 bg-black-pearl" large>
      <Title customClass="text-white pb-20 xl:pb-24" SubTitle="UI Design" />
      <Container className="overflow-hidden">
        <div
          ref={ResponsiveUIImageReference}
          className={`fs-0 pb-20 xl:pb-24 text-center ${
            imageVisible ? "animate-slide-up" : undefined
          }`}
        >
          <Image
            alt="uI design"
            height={962}
            src={"/assets/case-study/mobifinx/ui-design-1.webp"}
            width={1322}
          />
        </div>
      </Container>
      <Container>
        <div
          ref={ResponsiveUISecondImageReference}
          className={`fs-0 text-center ${
            secondImageVisible ? "animate-slide-up" : undefined
          }`}
        >
          <Image
            alt="uI design"
            height={962}
            src={"/assets/case-study/mobifinx/ui-design-2.webp"}
            width={1322}
          />
        </div>
      </Container>
    </Container>
  );
};
export default Ui;
